import { render, staticRenderFns } from "./SingleBudgetVariantSelection.vue?vue&type=template&id=131da207&"
import script from "./SingleBudgetVariantSelection.vue?vue&type=script&lang=ts&"
export * from "./SingleBudgetVariantSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports